import classNames from 'classnames'
import { HTMLProps } from 'react'

export function EmblaCarouselSlide({
  children,
  className,
  ...props
}: HTMLProps<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={classNames('min-w-0 flex-[0_0_100%]', className)}
    >
      {children}
    </div>
  )
}
